<template>
  <v-card>
    <v-card-title
      >Talep Gir <v-spacer></v-spacer>
      <div v-if="acente">
        <ul>
          <li><b>Acente no: </b>{{ acente.Kodu }}</li>
          <li><b>Acente Adı: </b>{{ acente.Adi }}</li>
        </ul>
      </div></v-card-title
    >
    <v-container>
      <v-form v-model="valid" lazy-validation ref="form">
        <v-row>
          <v-col cols="6">
            <v-card outlined>
              <v-card-title
                >Police Bilgileri <v-spacer></v-spacer> <i>{{ model.TarifeKod }}</i>
              </v-card-title>
              <v-container>
                <v-text-field
                  v-model="model.PoliceNo"
                  placeholder="POLİÇE NO"
                  label="Poliçe No"
                  type="number"
                  :rules="[
                    val => !!val || 'Poliçe numarası zorunludur!',
                    val => (!!val && getPolicyInfo(val)) || 'Poliçe bulunamadı!',
                  ]"
                ></v-text-field>
                <v-text-field
                  v-if="[28, 2, 3].includes(model.TalepTip)"
                  v-model="model.HasarDosyaNo"
                  placeholder="HASAR DOSYA NO"
                  label="Hasar Dosya No"
                  type="number"
                  :rules="[val => !!val || 'Dolu olması zorunludur!']"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="model.HasarDosyaNo"
                  placeholder="HASAR DOSYA NO"
                  type="number"
                  label="Hasar Dosya No"
                ></v-text-field>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card outlined>
              <v-card-title
                >Müşteri Bilgileri <v-spacer></v-spacer> <i>{{ ad_soyad }}</i>
              </v-card-title>
              <v-container>
                <v-autocomplete
                  v-model="model.tcknVKTip"
                  placeholder="KİMLİK TİPİ"
                  label="Kimlik Tipi"
                  :items="[
                    { value: 'TC', text: 'TC' },
                    { value: 'VK', text: 'VK' },
                  ]"
                ></v-autocomplete>
                <v-text-field
                  v-model="model.TCVK"
                  placeholder="TCKN/VK"
                  label="TCKN/VK"
                  type="number"
                  :rules="[
                    val =>
                      (model.tcknVKTip == 'TC' && val.length == 11) ||
                      (model.tcknVKTip == 'VK' && val.length == 10) ||
                      (model.tcknVKTip == 'TC' ? 'TCKN 11 haneli olmalı!' : 'VK 10 haneli olmalı!'),
                    val =>
                      (model.tcknVKTip == 'TC' && val.length == 11 && getCustomer(val)) ||
                      'Müşteri bulunamadı!' ||
                      (model.tcknVKTip == 'VK' && val.length == 10 && getCustomer(val)) ||
                      'Müşteri bulunamadı!',
                  ]"
                ></v-text-field>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title>Talep Durumları</v-card-title>
              <v-container>
                <v-autocomplete
                  v-model="model.TalepTur"
                  placeholder="TALEP TÜRÜ"
                  label="Talep Türü"
                  :items="$options.statics.talepTurleri"
                  :rules="[val => !!val || 'Talep türü seçimi zorunludur!']"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="model.TalepEdenTur"
                  placeholder="TALEP EDEN TÜRÜ"
                  label="Talep Eden Türü"
                  :items="$options.statics.talepEdenTurleri"
                  :rules="[val => !!val || 'Talep eden türü seçimi zorunludur!']"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="model.TalepKanal"
                  placeholder="TALEP KANALI"
                  label="Talep Kanalı"
                  :items="$options.statics.talepKanallari"
                  :rules="[val => !!val || 'Talep kanalı seçimi zorunludur!']"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="model.TalepTip"
                  placeholder="TALEP TİPİ"
                  label="Talep Tipi"
                  :items="sue_types.filter(x => x.parent_value == 0)"
                  :rules="[val => !!val || 'Talep tipi seçimi zorunludur!']"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="model.TalepDetay"
                  placeholder="TALEP DETAY"
                  label="Talep Detay"
                  :items="sue_types.filter(x => x.parent_value == model.TalepTip)"
                  :rules="[val => !!val || 'Talep detay seçimi zorunludur!']"
                ></v-autocomplete>
              </v-container>
            </v-card>
          </v-col>
          <v-col>
            <v-card outlined>
              <v-card-title>Talep Tarihleri</v-card-title>
              <v-container>
                <v-menu
                  ref="talepTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.TalepTarih"
                      placeholder="TALEP TARIHI"
                      label="Talep Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'Talep tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.TalepTarih" :max="getCurrentDate()" no-title scrollable>
                  </v-date-picker>
                </v-menu>
                <v-menu
                  ref="iletimTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.IletimTarih"
                      placeholder="İLETİM TARİHİ"
                      label="İletim Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'İletim tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.IletimTarih" no-title scrollable :max="getCurrentDate()">
                  </v-date-picker>
                </v-menu>
                <v-menu
                  ref="gelisTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.GelisTarih"
                      placeholder="GELİŞ TARİHİ"
                      label="Geliş Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'Geliş tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.GelisTarih" no-title scrollable :max="getCurrentDate()">
                  </v-date-picker>
                </v-menu>
                <v-menu
                  ref="cozumlenmeTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="model.CozumlenmeTarih"
                      placeholder="ÇÖZÜMLENME TARİHİ"
                      label="Çözümlenme Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'Çözümlenme tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.CozumlenmeTarih" no-title scrollable :max="getCurrentDate()">
                  </v-date-picker>
                </v-menu>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title>Talep Sonuçları</v-card-title>
              <v-container>
                <v-autocomplete
                  v-model="model.TalepSonuc"
                  placeholder="TALEP SONUCU"
                  label="Talep Sonucu"
                  :items="$options.statics.talepSonuclari"
                  :rules="[val => !!val || 'Talep sonucu seçimi zorunludur!']"
                ></v-autocomplete>
                <v-textarea
                  v-model="model.DetayAksiyon"
                  placeholder="DETAY AKSİYON"
                  label="Detay Aksiyon"
                  counter
                  :rules="[
                    val => !!val || 'Detay Aksiyon alanı zorunludur!',
                    val => (val && val.length >= 150) || 'Detay Aksiyon en az 150 karakter olmalıdır!',
                  ]"
                ></v-textarea>
                <v-autocomplete
                  v-model="model.GeriDonusKaynak"
                  placeholder="GERİ DÖNÜŞ KAYNAK"
                  label="Geri Dönüş Kaynak"
                  :items="$options.statics.geriDonusKaynaklari"
                  :rules="[val => !!val || 'Geri dönüş kaynağı seçimi zorunludur!']"
                ></v-autocomplete>
                <v-menu
                  ref="iptalTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-if="[363, 219, 315, 220, 331, 364, 317, 460, 83, 105, 369, 424, 227].includes(model.TalepDetay)"
                      v-model="model.IptalTarih"
                      placeholder="İPTAL TARİHİ"
                      label="İptal Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'İptal tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="model.IptalTarih"
                      placeholder="İPTAL TARİHİ"
                      label="İptal Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.IptalTarih" no-title scrollable> </v-date-picker>
                </v-menu>
                <v-text-field
                  v-if="[363, 219, 315, 220, 331, 364, 317, 460, 83, 105, 369, 424, 227].includes(model.TalepDetay)"
                  v-model="model.TahsilatTutar"
                  placeholder="TAHSİLAT TUTARI"
                  label="Tahsilat Tutarı"
                  type="number"
                  :rules="[val => !!val || 'Tahsilat tutarının girilmesi zorunludur!']"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="model.TahsilatTutar"
                  placeholder="TAHSİLAT TUTARI"
                  type="number"
                  label="Tahsilat Tutarı"
                ></v-text-field>
                <v-menu
                  ref="iadeTarih"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-if="[363, 219, 315, 220, 331, 364, 317, 460, 83, 105, 369, 424, 227].includes(model.TalepDetay)"
                      v-model="model.IadeTarih"
                      placeholder="İADE TARİHİ"
                      label="İade Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      :rules="[val => !!val || 'İade tarihi seçimi zorunludur!']"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      v-model="model.IadeTarih"
                      placeholder="İADE TARİHİ"
                      label="İade Tarihi"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.IadeTarih" no-title scrollable> </v-date-picker>
                </v-menu>
                <v-text-field
                  v-if="[363, 219, 315, 220, 331, 364, 317, 460, 83, 105, 369, 424, 227].includes(model.TalepDetay)"
                  v-model="model.IadeTutar"
                  placeholder="İADE TUTARI"
                  type="number"
                  label="İade Tutarı"
                  :rules="[val => !!val || 'İade tutarının girilmesi zorunludur!']"
                ></v-text-field>
                <v-text-field
                  v-else
                  v-model="model.IadeTutar"
                  placeholder="İADE TUTARI"
                  type="number"
                  label="İade Tutarı"
                ></v-text-field>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions fill-height class="axa-dialog-footer m-mt-a">
        <v-spacer />
        <v-btn :block="$vuetify.breakpoint.smAndDown" class="ma-2 axa-btn type-outline" @click="$emit('close')">
          Vazgeç
        </v-btn>
        <v-btn
          :block="$vuetify.breakpoint.smAndDown"
          :disabled="!valid"
          class="ma-2 axa-btn type-dark big-60"
          @click="save()"
        >
          Kaydet
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>
<script>
import { eventBus } from '../../main';
import statics from '../../core/utils/statics/customerComplaint.static';
import { mapActions } from 'vuex';
export default {
  statics,
  props: {
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      acente: {},
      model: {
        TalepTur: 1,
        tcknVKTip: 'TC',
        TCVK: '',
        ad_soyad: null,
        PoliceNo: null,
        PoliceBaslangicTarih: null,
        PoliceBitisTarih: null,
        TarifeKod: null,
        BransKod: 'Elementer',
        HasarDosyaNo: null,
        TalepEdenTur: null,
        TalepKanal: null,
        TalepTarih: null,
        Tarih: null,
        IletimTarih: null,
        GelisTarih: null,
        CozumlenmeTarih: null,
        CozumSure: null,
        TalepTip: null,
        TalepDetay: null,
        TalepSonuc: null,
        DetayAksiyon: null,
        GeriDonusKaynak: null,
        IptalTarih: null,
        TahsilatTutar: null,
        IadeTarih: null,
        IadeTutar: null,
        OPID: null,
      },
      valid: false,
      sue_types: [],
      loading: true,
    };
  },
  async created() {
    if (this.type == 'edit') {
      this.model = this.item;
      this.model.TalepTarih = this.getDate(this.model.TalepTarih);
      this.model.IletimTarih = this.getDate(this.model.IletimTarih);
      this.model.GelisTarih = this.getDate(this.model.GelisTarih);
      this.model.CozumlenmeTarih = this.getDate(this.model.CozumlenmeTarih);
      this.model.IptalTarih = this.getDate(this.model.IptalTarih);
      this.model.IadeTarih = this.getDate(this.model.IadeTarih);
      this.model.tcknVKTip = 'VK';
      if (this.model.TCVK.length > 10) this.model.tcknVKTip = 'TC';
    }
    await Promise.all([this.$store.dispatch('getAgencyDetails', {})]);
    this['acente'] = (
      await this.$store.dispatch('getAgencyInfo', {
        subeKod: this.$store.getters.agencyDetails['AcentaNo'],
        kaynakKod: this.$store.getters.agencyDetails['AcentaNo'],
      })
    ).Data[0];
    if (this.acente) this.model.AcenteNo = this.acente.Kodu;
    this.model.OPID = this.$store.getters.agencyDetails['Kullanici'];
    this.sue_types = this.$store.getters.GetSueTypeDetails.map(x => ({
      value: x.Kod,
      text: x.Ad,
      parent_value: x.ParentID,
    }));
    this.loading = false;
  },
  methods: {
    ...mapActions([
      'sendMailCommon',
    ]),
    async getCustomer() {
      if (this.model.TCVK.length == 10 || this.model.TCVK.length == 11) {
        var data = {
          SahisFirma: this.model.tcknVKTip == 'TC' ? 'Sahis' : 'Firma',
          KimlikTipi: this.model.tcknVKTip,
          KimlikNo: this.model.TCVK,
        };
        await this.$store.dispatch('searchCustomer', data);
        if (this.$store.getters.SearchCustomer.Items.length > 0) {
          this.ad_soyad = this.$store.getters.SearchCustomer.Items[0].MusteriAdi.replace('  ', ' ');
          return true;
        }
      }
      return false;
    },
    async getPolicyInfo(pol_no) {
      if (pol_no && pol_no.length >= 9) {
        const policy = await this.$store.dispatch('searchPolicy', {
          user_guid: this.$store.state.login.agencyDetails.UserGuid,
          key: pol_no,
        });
        if (policy['Data'].length > 0) {
          let bas = policy['Data'][0].baslama_tarih.substr(0, 10).split('/');
          let bit = policy['Data'][0].bitis_tarih.substr(0, 10).split('/');
          [bas, bit] = [`${bas[2]}-${bas[1]}-${bas[0]}`, `${bit[2]}-${bit[1]}-${bit[0]}`];
          this.model.PoliceBaslangicTarih = new Date(bas);
          this.model.PoliceBitisTarih = new Date(bit);
          this.model.TarifeKod = policy['Data'][0].tarife_kod;
          this.model.BransKod = policy['Data'][0].BransKod;
          return true;
        } else {
          this.model.PoliceBaslamaTarih = null;
          this.model.PoliceBitisTarih = null;
          this.model.TarifeKod = null;
          this.model.BransKod = null;
        }
      } else {
        this.model.PoliceBaslamaTarih = null;
        this.model.PoliceBitisTarih = null;
        this.model.TarifeKod = null;
        this.model.BransKod = null;
      }
      return false;
    },
    async save() {
      let result = null;
      if (this.type == 'create') result = await this.$store.dispatch('postCustomerComplaintReport', this.model);
      else result = await this.$store.dispatch('putCustomerComplaintReport', this.model);
      if (result.data.Basarili) {
        eventBus.$emit('InfoSnackbar', {
          statePath: {
            Mesajlar: [
              {
                Kod: '1',
                Mesaj: result.data.Mesajlar.Bilgiler[0],
                Tip: 'Bilgi',
                Yer: '',
              },
            ],
          },
        });
        this.$emit('close', true);
      await this.needInfoFuncModal();
      } else
        eventBus.$emit('AlertError', {
          modalName: 'errorModal',
          modalState: true,
          title: 'Hata',
          desc: 'Şikayet eklemesi gerçekleşemedi!',
          type: 'error',
        });
    },
      async needInfoFuncModal() {
        let talepMesaj = 'Şikayet Raporu '+ '\r\n\r\n\r\n';
 
        for (let index = 0; index < this.model.length; index++) {
          const madMsg = this.model[index];
          talepMesaj += madMsg.Mesaj + '\r\n';
        }
 
       
        Object.keys(this.model).forEach(key => {
          let value = this.model[key];
          if (value === null || value === undefined) {
            value = 'Bilgi yok';
          }
          talepMesaj += `${key}: ${value}\r\n`;
        });
 
        await this.sendMailCommon({
          from: 'AXA SİGORTA <axasigorta@axasigorta.com.tr>',
          to: 'iletisim@axasigorta.com.tr;tuna.erman@axasigorta.com.tr',
          subject: 'AxaTek Şikayet Raporu',
          body: talepMesaj,
        });
      },
 
 
 
    getDate(val) {
      return val.substr(0, 10);
    },
    getCurrentDate() {
      let currentDate = new Date();
      return `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1 < 10 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1
      }-${currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()}`;
    },
  },
  computed: {
    ad_soyad: {
      get() {
        return this.model.ad_soyad;
      },
      set(val) {
        this.model.ad_soyad = val;
      },
    },
  },
};
</script>
<style scoped>
li {
  list-style: none;
}
</style>
 